import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { ResizeObserverService } from 'src/app/shared/services/resize-observer-service/resize-observer.service';

@Component({
    selector: 'app-standard-dropdown-resizable-menu',
    templateUrl: './standard-dropdown-resizable-menu.component.html',
    styleUrls: ['./standard-dropdown-resizable-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StandardDropdownResizableMenuComponent implements OnInit {
    @Input() public maxWidth = 576;
    @Input() public isAutoClose = true;

    @ViewChild('toolbarWrapper', { read: ElementRef, static: true }) private toolbarWrapperElement: ElementRef<HTMLElement>;

    public isSmallScreen = true;
    private changeDetectorRef = inject(ChangeDetectorRef);
    private resizeObserverService = inject(ResizeObserverService);

    public ngOnInit(): void {
        this.resizeObserverService.observe(this.toolbarWrapperElement, () => this.setToolBarView());
    }

    private setToolBarView() {
        const { width } = (this.toolbarWrapperElement.nativeElement as HTMLDivElement).getBoundingClientRect();

        if (width <= this.maxWidth) {
            this.isSmallScreen = true;
        } else {
            this.isSmallScreen = false;
        }

        this.changeDetectorRef.detectChanges();
    }
}
